import { AppNavigation } from '@/components/app-navigation';
import { AppShell, Burger, Group, TextInput } from '@mantine/core';
import { Link, Outlet, useNavigate } from 'react-router';
import { useDisclosure } from '@mantine/hooks';
import logo from '@/assets/img/duck_avatar_final.webp';
import React from 'react';
import { IconSearch } from '@tabler/icons-react';

export function AppLayout() {
    const navigate = useNavigate();
    const [ mobileOpened, { toggle: toggleMobile, close: closeMobile } ] = useDisclosure();
    const [ desktopOpened, { toggle: toggleDesktop } ] = useDisclosure(true);
    
    function onSearch(value: string) {
        navigate(`/users?page=1&search=${ value }`);
    }
    
    return (
        <AppShell
            padding='md'
            header={ { height: 56 } }
            navbar={ {
                width: 200,
                breakpoint: 'sm',
                collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
            } }
            transitionDuration={ 300 }
            transitionTimingFunction='ease'
        >
            <AppShell.Header>
                <Group h='100%' px='md'>
                    <Group>
                        <Link to='/' style={ {
                            display: 'flex',
                            alignItems: 'center',
                            color: '#fff',
                            gap: '8px',
                            marginRight: 16,
                            textDecoration: 'none',
                            fontWeight: 500,
                        } }>
                            <img src={ logo } style={ { maxWidth: '32px' } } alt='Spy Duck VPN'/>
                            SpyDuck Admin
                        </Link>
                    </Group>
                    <Group flex={ 1 }>
                        <TextInput
                            placeholder='Поиск пользователей'
                            onChange={ (e) => onSearch(e.target.value) }
                            leftSection={(
                                <IconSearch size={14} />
                            )}
                            w='100%'
                        />
                    </Group>
                    <Group align='end'>
                        <Burger opened={ mobileOpened } onClick={ toggleMobile } hiddenFrom='sm' size='sm'/>
                        <Burger opened={ desktopOpened } onClick={ toggleDesktop } visibleFrom='sm' size='sm'/>
                    </Group>
                </Group>
            </AppShell.Header>
            <AppShell.Navbar withBorder pt={14}>
                <AppNavigation
                    onNavLinkClick={() => {
                        closeMobile();
                    }}
                />
            </AppShell.Navbar>
            <AppShell.Main>
                <Outlet/>
            </AppShell.Main>
        </AppShell>
    )
}